export const convertBytesToMb = (sizeBytes: number) => sizeBytes / (1024 * 1024);
